/**
 * Report error control button.
 *
 * Implements IControl:
 * https://docs.mapbox.com/mapbox-gl-js/api/markers/#icontrol
 */
import { ModalComponentService } from "../common/ModalComponentService";
import type { IControl, Map } from 'mapbox-gl';

class ReportErrorControl implements IControl {
    _map: Map | undefined;
    _container = document.createElement('div');
    _button = document.createElement('button');
    CLASS_BUTTON_REPORT_ERROR = 'button_report_error';
    CLASS_BUTTON_CONTROL = 'mapboxgl-ctrl';

    handleButtonClick(): void {
        ModalComponentService
            .openModalComponent(ModalComponentService.ModalComponentTypes.REPORT_ERROR_CARD);
    }

    onAdd(map: Map): HTMLElement {
        this._map = map;
        this._container.className = this.CLASS_BUTTON_CONTROL + ' mapboxgl-ctrl-group';
        this._button.className = this.CLASS_BUTTON_REPORT_ERROR;
        this._button.addEventListener('click', this.handleButtonClick.bind(this));
        this._container.appendChild(this._button);
        return this._container;
    }

    onRemove(): void {
        this._container.parentNode!.removeChild(this._container);
        this._map = undefined;
    }
}

export default ReportErrorControl;
